import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-global-issue-sync",
  "use": "icon-soc-global-issue-sync-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" fill=\"none\" id=\"icon-soc-global-issue-sync\">\n  <!-- ??????????? + ???? -->\n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"64\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n    <circle cx=\"320\" cy=\"512\" r=\"128\" />\n    <circle cx=\"704\" cy=\"512\" r=\"128\" />\n    <path d=\"M416 384c64-96 192-128 288-64\" />\n    <path d=\"M608 640c-64 96-192 128-288 64\" />\n    <path d=\"M672 288l64 64-64 64M352 736l-64-64 64-64\" />\n    <circle cx=\"320\" cy=\"512\" r=\"32\" fill=\"currentColor\" stroke=\"none\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-global-issue-sync.svg
// module id = CuK1
// module chunks = 488